export default __webpack_public_path__ + "static/media/resume_button.4ee3cf6a.png";